import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
import { getAllFilesBys3Key } from "../../../../store/actions/CreateContent/FolderAPI/LessonAPI";
import FileItemCard from "./FileItemCard";
import QuickViewItemCard from "./QuickViewItemCard";
import { Calendar, Filter } from "lucide-react";
import DropDownButtonUI from "../../CreateWebsite/DesignElements/DropDownButtonUI";
import UploaderPagination from "./UploaderPagenation";
import CalendarUploader from "./CalandarUploader";
import CreateNewFileListName from "./CreateNewFileListName";
import { getAllFileListByUser } from "../../../../store/actions/CreateContent/FolderAPI/ListAPIs";

const AllFilesInListName =({ getFileObject,setCloseListFilesPopUp,listObject,fileObject,setCurrentFileObject,fileTypeObject})=>{
     const App = useSelector((state)=>state?.app?.app);
        const [Courses,setCourses] =useState([])
        const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{},{},{},{},{},{},{},{}])
         const [animate, setAnimate] = useState(false);
         
        const dispatch = useDispatch();  
      
        const currentToken = useSelector((state)=>state?.user?.user?.token);
        const user_email = useSelector((state)=>state?.user?.user?.user_email
       );
       const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
       const appId = useSelector((state)=>state?.app?.app?.ID);
       const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
            
       const [snackbarVisible, setSnackbarVisible] = useState(false);
        
       const [closeQuickViewPopUp, setCloseQuickViewPopUp] = useState(false);
       const [quickViewItem ,setQuickViewItem] =useState({})
        const [snackbarColor, setSnackbarColor] = useState("#958FDA");
        const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
          const [itemArr, setItemArr] = useState([]);
             const [sort, setSort] = useState("DESC");
          const [pageNo, setPageNo] = useState(1);
        const [startDate, setStartDate] = useState("");
       const [endDate, setEndDate] = useState("");
       const [editType, setEditType] = useState("getAllFilesByFileType");
       const [fileType, setFileType] = useState(fileTypeObject[0]?.value);
       const [limit, setLimit] = useState(12);
       const [currentPage, setCurrentPage] = useState(0);
       const [ totalPages, setTotalPages] = useState(0);
       const [ reloadCalendar, setReloadCalendar] = useState(true);
       const [ closeFileListsPopUp, setCloseFileListsPopUp] = useState(false);
      
                        const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{},{},{},{},{},{},{},{},{}]);   
        const showSnackbar = () => {
         setSnackbarVisible(true);
       };
       
        const hideSnackbar = () => {
         setSnackbarVisible(false);
       };
     
           const [loader , setLoader] =useState({status:false});
          const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
              {
                
                dispatch({type: "CURSOR",payload:true  });
            
                dispatch({type: "CURSORTEXT",payload:CursorText})
                dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
                dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
              }
               
              const handleMouseLeave = () => {
                
                dispatch({type: "CURSOR",payload:false})
            
                dispatch({type: "CURSORTEXT",payload:""})
            
                dispatch({type: "CURSORTEXTBG",payload:""})
                dispatch({type: "CURSORTEXTCOLOR",payload:""})
              
            
            } 
             function convertToYMD(dateStr) {
                
  const [day, month, year] = dateStr?.split("-");
  return `${year}-${month}-${day}`;
}
function formatDate(dateStr) {
  if (!dateStr) return { isoDate: "Invalid", readable: "Invalid date" };

  // Normalize separators (in case it's "27/06/2025" etc.)
  const clean = dateStr.replace(/\//g, "-").trim();

  const parts = clean.split("-");
  if (parts.length !== 3) return { isoDate: "Invalid", readable: "Invalid date" };

  let day, month, year;

  // Detect format:
  // If first part has 4 digits → YYYY-MM-DD
  if (parts[0].length === 4) {
    [year, month, day] = parts;
  } else {
    [day, month, year] = parts;
  }

  // Pad for safety
  day = day.padStart(2, "0");
  month = month.padStart(2, "0");

  const isoDate = `${year}-${month}-${day}`;
  const date = new Date(isoDate);

  if (isNaN(date)) return { isoDate: "Invalid", readable: "Invalid date" };

  // Readable format — e.g. "27 June, 2025"
  const readable = date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  return { isoDate, readable };
}
 const videoSettingsObject ={
                        
                            videoThumbnail:{
                                src:"",hideThumbnail:true,
                                            },
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:50,resolution:"px"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(144, 202, 249,1))",color5:"rgba(187, 247, 247, 0.93)"},alpha:1}
                                     ,hover:{title:"Slide & Title Background Color",color:"rgba(127, 176, 131, 1)",colors:{color10:"rgba(144, 202, 249,1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       }
const downloadFileClick = async (item) => {
    if(true){
       
  
  try {
    
    const fileUrl =item?.fileUrl;
        let fileName = item?.fileUrl?.split("/").pop();
    if (fileName?.includes("?")) fileName = fileName?.split("?")[0];
    
    // 🔹 Trigger browser download
    const a = document.createElement("a");
    a.href = fileUrl;
    a.target='_blank';
    a.download = decodeURIComponent(fileName);
    document.body.appendChild(a);
    a.click();
    a.remove();

    // Cleanup
    window.URL.revokeObjectURL(fileUrl);
  } catch (error) {
    console.error("Error downloading file:", error);
    alert("Could not download the file. Please try again.");
  }
  }
};        
const handlePageChange = (page) => {
    
    setPageNo(page);
  };
  function getTotalPages(total, limit) {
  if (!limit || limit <= 0) return 1; // avoid division by zero
  return Math.ceil(total / limit);
}
useEffect(()=>{
    FireGetAllFilesBys3Key()
},[sort,pageNo,startDate,endDate,fileType,limit,editType,])
  
const FireGetAllFilesBys3Key=(e)=>{

     setItemArr([])
     setItemArrLoading([{},{},{},{},{},{},{},{},{},{},{},{}])
     let getFilesObject;
    

       
setLoader({status:true});
  const apiData = dispatch(getAllFileListByUser({userEmail:user_email?user_email:null,
  currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,postParent:listObject?.id,
  sort:sort,pageNo:pageNo,startDate:startDate,endDate:endDate,fileType:fileType=="all"?"":fileType,limit:limit,

  editType:"getAllFileByFileListNamesId"}));
  /* get response as Promise   */
  apiData.then(response => {
    if(response){

    //   console.log(response)
      if(response?.files){
    setResponseMessage(response?.message);
    setSnackbarColor("rgba(144, 202, 249,1)");
  setCurrentPage(response?.page)
  setTotalPages(response?.total)
     setItemArr(response?.files);
     setItemArrLoading([])
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
},1000)
   }else{
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
   }
      
   
   if(response?.logout){
   
    setResponseMessage("You are Logged Out!!!");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});

    },3000)
    
  }
/* resetting Login input Fields */

    }else{
      setResponseMessage("Something Went Wrong...");
      
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    console.error(error);
  });
 
  }
  


  const flattenedData = itemArr!=[]?Object.values(itemArr):'';

         const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
 


        
   return(<>
 <div    onClick={()=>setCloseListFilesPopUp(false)} className="PopUpUploaderOpacityUploader"  style={{cursor:"pointer"}}> </div>
        <div   className="PopUpUploader" style={{borderRadius: '0px'}}> 
        <div style={{display:"flex",justifyContent:"space-between",padding:"10px"}}>
            <h2>   <div className="" style={{fontSize:"24px",marginTop:"-10px"}} >{listObject?.file_list_name} </div> </h2>
          <div style={{display:"flex",justifyContent:"space-between",padding:"10px",gap:"10px"}}>
              <div style={{marginTop:"-10px",transform:"scale(0.8)",position:"relative",zIndex:"9999999"}}><DropDownButtonUI activeCard={""} icon={4} title={fileType} 
                 onClickSendObject={(value)=>{  
                                    if(value){setFileType(value);setPageNo(1) }}}
                  hasDropDown={true} dropDownObject={fileTypeObject} />
                                                                                    
                                                                                    </div>  
 <div  className="calendarOuter" style={{border:"2px solid rgba(144, 202, 249,1)",cursor:"pointer",width:"30px",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"5px",background:"rgba(144, 202, 249,1)",}}>
<Calendar size={18} color={"#ffffff"} />
<div className="calendarInner">
    <div style={{position:"absolute",}}>
 {reloadCalendar?<CalendarUploader returnSelectedRange={(v)=>{setStartDate(convertToYMD(v?.from));setEndDate(convertToYMD(v?.to));}} />:""}
     </div>
     </div>
</div>

             <div onClick={()=>{}} className="sortOuter" style={{border:"2px solid rgba(144, 202, 249,1)",cursor:"pointer",width:"30px",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"50px",background:"rgba(144, 202, 249,1)",}}>
<Filter size={18} color={"#ffffff"} />
<div className="sortInner">
 
    <div onClick={()=>{setSort("ASC")}} className="sortInnerItem" style={sort=="ASC"?{background:"rgba(144, 202, 249,1)",color:"#ffffff"}:{background:"#ffffff",color:"rgba(144, 202, 249,1)"}}>Ascending Order</div>
    <div onClick={()=>{setSort("DESC")}} className="sortInnerItem" style={sort=="DESC"?{background:"rgba(144, 202, 249,1)",color:"#ffffff"}:{background:"#ffffff",color:"rgba(144, 202, 249,1)"}}>Descending Order</div>
    </div>
</div> </div> 
            </div>
     <h5 style={{marginTop:"-25px",padding:"5px"}}>Showing {itemArr?.length} {fileType!=="all"?fileType:""} file{itemArr?.length>1?"s":""} in {sort=="ASC"?"Ascending":"Descending"} order 
         {startDate?" from "+formatDate(startDate)?.readable:""} {  startDate!==endDate&&endDate?"to "+formatDate(endDate)?.readable:startDate?"to (select end date)":"" }  {startDate||endDate?<span onClick={()=>{setStartDate("");setEndDate("");setReloadCalendar(false);setTimeout(()=>{setReloadCalendar(true)},100)}} style={{cursor:"pointer",width:"100px",color:"rgba(144, 202, 249,1)"}}> Clear dates</span>:""}
 
     </h5>
  
<div className="PopUpUploaderHeight" style={{padding:"10px"}}>
              <div align="center" >
              
                   <div className="gridFilesShow" >
                    
    {flattenedDataLoading?flattenedDataLoading?.map((item, index) => (
  <div key={index} style={{width:"160px",border:"2px solid #f1f1f1",height:"100px" }}    >
       
            <div
className={""  }
             style={{ margin:"0px",marginTop:"-5px",
                marginRight:"0px",position:"relative",borderRadius:"10px",overflow:"hidden"}} 
          
             
            >  <div  style={{display:"flex",justifyContent:"space-between" }}>
          <div  className="">
                     </div> <div   style={{width:"155px",marginTop:"0px",fontWeight:"999"}}  >
                   <div  className="TitleWithEllipsis" style={{width:"150px",marginTop:"10px",fontWeight:"999"}}  >
                 
                   </div>  </div>  </div>  </div>  </div> )):""} 
     {flattenedDataLoading?.length==0?flattenedData?.length?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.ID}  style={{}}  >
 <FileItemCard  getFileObject={(v)=>{getFileObject(v)
        }} setCloseFileListsPopUp={(v)=>{setCloseFileListsPopUp(true)}} videoSettingsObject={videoSettingsObject} item={item}  setCloseQuickViewPopUp={()=>{setCloseQuickViewPopUp(true)}}
  setQuickViewItem={(i)=>{setQuickViewItem(i)}}  downloadFileClick={(v)=>{downloadFileClick(v)}}  />
 </div>)):"":""}</div></div>
 <h2 style={{display:"flex",justifyContent:"center"}}>{flattenedData?.length==0?"No Files Found":""}</h2>
<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"10px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"0px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>
    <button  onClick={()=>{setCloseListFilesPopUp(false)}}    className=" MocktestUploaderBtn"  type="submit"
 > Cancel </button>
 <div style={{marginTop:"15px",display:"flex",justifyContent:"center",alignItems:"center",gap:"10px",width:"280px"}}>
 <UploaderPagination  currentPage={currentPage}
        totalPages={getTotalPages(totalPages,limit)}
        // totalPages={50}
        onPageChange={handlePageChange} />
        <div onClick={()=>{}} className="limitOuter" style={{border:"2px solid rgba(144, 202, 249,1)",cursor:"pointer",width:"30px",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"5px",background:"rgba(144, 202, 249,1)",}}>
{limit}
<div className="limitInner" >
 
    <div onClick={()=>{setLimit(12)}} className="limitInnerItem" style={limit==12?{background:"rgba(144, 202, 249,1)",color:"#ffffff"}:{background:"#ffffff",color:"rgba(144, 202, 249,1)"}}>12</div>
    <div onClick={()=>{setLimit(24)}} className="limitInnerItem" style={limit==24?{background:"rgba(144, 202, 249,1)",color:"#ffffff"}:{background:"#ffffff",color:"rgba(144, 202, 249,1)"}}>24</div>
    <div onClick={()=>{setLimit(36)}} className="limitInnerItem" style={limit==36?{background:"rgba(144, 202, 249,1)",color:"#ffffff"}:{background:"#ffffff",color:"rgba(144, 202, 249,1)"}}>36</div>
    <div onClick={()=>{setLimit(48)}} className="limitInnerItem" style={limit==48?{background:"rgba(144, 202, 249,1)",color:"#ffffff"}:{background:"#ffffff",color:"rgba(144, 202, 249,1)"}}>48</div>
    </div></div>
</div>
<button  onClick={()=>{setCloseListFilesPopUp(false)}}   style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" MocktestUploaderBtn"  type="submit"
 > Select </button>
</div> 
</div></div>
{closeFileListsPopUp?<CreateNewFileListName setCloseFileListsPopUp={()=>{setCloseFileListsPopUp(false)}}/>:""}
<style>{`

 .sortInnerItem{height:20px;cursor:pointer;display:flex;justify-content:left;gap:8px;background:#fff;padding:3px 5px;border-radius:5px;margin-bottom:5px}
    .sortOuter .sortInner{z-index:999999;border:2px solid rgba(144, 202, 249,1);width:125px;height:60px;background:rgba(228, 237, 244, 1);;border-radius:5px;position:absolute;top:70px;right:15px;visibility:hidden;opacity:0;transition: 0.1s ease;}
     .sortOuter:hover .sortInner{visibility:visible;opacity:1;transition: 0.1s ease;padding:5px}

 .sortInner::after {
    content: "";
    position: absolute;
   top: -16px;
    right: 0px;
    margin-left: 2px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent  transparent rgba(144, 202, 249,1)   transparent ;
  }
   .sortInnerItem:hover{transform:scale(0.9);transition: 0.1s ease;}
   
     .calendarOuter .calendarInner{transform:scale(0.6);
     z-index:999999;border:2px solid rgba(144, 202, 249,1);width:340px;height:410px;background:#ffffff;border-radius:15px;position:absolute;top:5px;right:-5px;visibility:hidden;opacity:0;transition: 0.1s ease;}
     .calendarOuter:hover .calendarInner{transform:scale(0.7);visibility:visible;opacity:1;transition: 0.1s ease;padding:5px}

 .calendarInner::after {
    content: "";
    position: absolute;
   top: -16px;
    right: 45px;
    margin-left: 2px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent  transparent rgba(144, 202, 249,1)   transparent ;
  }
 .limitOuter{position:relative;}
   .limitInnerItem{height:20px;cursor:pointer;display:flex;justify-content:left;gap:8px;background:#fff;padding:3px 5px;border-radius:5px;margin-bottom:5px}
    .limitOuter .limitInner{z-index:999999;border:2px solid rgba(144, 202, 249,1);width:30px;height:120px;background:rgba(228, 237, 244, 1);;border-radius:5px;position:absolute;bottom:40px;right:-5px;visibility:hidden;opacity:0;transition: 0.1s ease;}
     .limitOuter:hover .limitInner{visibility:visible;opacity:1;transition: 0.1s ease;padding:5px}

 .limitInner::after {
    content: "";
    position: absolute;
   bottom: -16px;
    right: 12px;
    margin-left: 2px;
    border-width: 8px;
    border-style: solid;
    border-color: rgba(144, 202, 249,1)  transparent  transparent    transparent ;
  }
   .limitInnerItem:hover{transform:scale(0.9);transition: 0.1s ease;}

 .mockTestUploaderTextbox, .mockTestUploaderTextbox:hover, .mockTestUploaderTextbox:focus{
    background: #f9f9f9;
    box-shadow:var(--shadow-default);
   color:#222;
   padding: 15px;
   margin:10px;outline: #fff;
   border: 3px solid rgba(144, 202, 249,1) !important;
   border-radius: 10px;;
}
  .PopUpUploaderHeight{overflow-y:auto;height:270px;padding:3px;padding-bottom:50px;}
.MocktestUploaderBtn{ 
    box-shadow:0 7px 20px 0 rgba(1,1,1,0.0501);
    font-size: 14px;;cursor: pointer;
    color:rgba(149, 143, 218,0.8);
font-weight:600 !important;width:95px;float: right ;
   cursor: pointer;
padding: 9px 5px ;
font-weight:600 !important;
 border:0px dashed #ffffff ;
    margin:15px;;
    background:#ffffff;border-radius: 10px;;
    text-align: center;
   }
  
.mockTestColoredTextV1Uploader {
         animation: background-pan-b24b2865 0.9s linear infinite;
        animation-duration: 0.9s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: normal;
        animation-fill-mode: none;
        animation-play-state: running;
        animation-name: background-pan-b24b2865;
 
        animation-timeline: auto;
        animation-range-start: normal;
        animation-range-end: normal;
        background: linear-gradient(to right, #8142e3, #86c2ff);
        -webkit-background-clip: text;
        background-size: 200%;
        -webkit-text-fill-color: transparent;
    }
.PopUpUploaderOpacityUploader{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:5px;
        background: rgba(20, 20, 20, 0.1);;
        z-index:9999999999 !important}
        
        .PopUpUploader{position:fixed;
    left:20%;
    right:20%;
    background: #ffffff;
    top:15%;bottom:15%;
    padding:5px;
    z-index:99999999999 !important;}

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
 .PopUpUploaderHeight{height:55vh;}
    .PopUpUploader{position:fixed;top:0px;
        left:10%;
        right:10%;top:10%;bottom:10%;
       }}

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {
.PopUpUploaderHeight{height:55vh;}
  .PopUpUploader{position:fixed;top:0px;
                left:10%;
                right:10%;top:10%;bottom:10%;
               }} 

/* xs */
@media (max-width: 767px) {
    .PopUpUploaderHeight{height:72vh;}
    .PopUpUploader{
       
        top:0px!important; height:100% !important;
        left:0%;border-radius: 0px !important;
        right:0%;
        bottom:0%!important;
    }
        }
        `}</style>


        {closeQuickViewPopUp?<QuickViewItemCard  videoSettingsObject={videoSettingsObject}  setCloseQuickViewPopUp={()=>{setCloseQuickViewPopUp(false)}} 
  setQuickViewItem={(i)=>{setQuickViewItem(i)}}  downloadFileClick={(v)=>{downloadFileClick(v)}}
            item={quickViewItem}/>:""}

            <style>{`
            .gridFilesShow{display:grid;grid-template-columns:24% 24% 24% 24%; gap:10px}

            
/* md */
@media (min-width: 992px) and (max-width: 1199px) {
.gridFilesShow{display:grid;grid-template-columns:32% 32% 32%}

 }

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {
.gridFilesShow{display:grid;grid-template-columns:32% 32% 32% }
} 

/* xs */
@media (max-width: 767px) {
.gridFilesShow{display:grid;grid-template-columns:48% 48% }}
            `}</style>
    </>)
}
export default AllFilesInListName;